<mat-tab-group
  (animationDone)="onAnimationDone()"
  (selectedIndexChange)="indexChange()"
  [(selectedIndex)]="selectedTab"
  class="custom_tabs_container"
>
  <ng-container *ngFor="let tab of tabs; let i = index">
    <mat-tab [label]="tab.label" [disabled]="animationRunning || tab.disabled">
      <ng-container *ngIf="selectedTab == i">
        <ng-template [ngComponentOutlet]="tab.component"></ng-template>
      </ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>
